import React from 'react'
import { PanelTitle } from './InventoryShared';

function ReportsAnalyticsPage() {
    const reports = ['Daily Consumption Report', 'Monthly Purchase Report', 'Wastage Report', 'Food Cost Report', 'Supplier Report'];

    return (
        <section className='inventory-panel inventory-form-page'>
            <PanelTitle title='Reports & Analytics' />
            <div className='inventory-report-list'>
                {reports.map(item => <button key={item}>{item}</button>)}
            </div>
            <div className='inventory-actions sticky'>
                <button>Export PDF</button>
                <button>Export Excel</button>
            </div>
        </section>
    );
}

export default ReportsAnalyticsPage
